import * as Material from "@mui/material";

import "./styles.css";

import Screen from "@components/Screen";

import { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { AccountBalanceRounded } from "@mui/icons-material";

import BankOnboardingCard from "./components/BankOnboardingCard";
import api from "@helpers/api";
import ChargesHistorySection from "./tabs/Charges";
import SubscriptionsSection from "./tabs/Subscriptions";
import WithdrawalSection from "./tabs/Withdrawals";
import Balance from "./components/Balance";
import TabsSelector from "@components/TabsSelector";

import { Text } from "@fragments";

const tabsConfig = [
    {
        key: 'history',
        label: 'Histórico de cobranças',
        screenTitle: 'Cobranças',
        screenUrl: 'banking/charges',
        path: '/banking/charges',
        component: <ChargesHistorySection />,
        showInTabs: true,
        match: (path) => path.includes('/banking/charges')
    },
    {
        key: 'subscriptions',
        label: 'Assinaturas',
        screenTitle: 'Assinaturas',
        screenUrl: 'banking/subscriptions',
        path: '/banking/subscriptions',
        component: <SubscriptionsSection />,
        showInTabs: true,
        match: (path) => path.includes('/banking/subscriptions')
    },
    {
        key: 'withdrawals',
        label: 'Saques',
        screenTitle: 'Saques',
        screenUrl: 'banking/withdrawal',
        path: '/banking/withdrawal',
        component: <WithdrawalSection />,
        showInTabs: true,
        match: (path) => path.includes('/banking/withdrawal'),
    },
    {
        key: 'anticipations',
        path: '/banking/anticipations',
        showInTabs: false,
        match: (path) => path.includes('/banking/anticipations')
    },
    {
        key: 'commissions',
        label: 'Comissões',
        disabled: true,
        badge: 'Em breve',
        showInTabs: true
    }
]

export default function Banking() {
    document.title = "Banking | Ginastee";

    const location = useLocation();

        const navigate = useNavigate();


    // Determinar a aba inicial baseada na rota
    const getInitialTab = () => {
        const path = location.pathname;
        const foundTab = tabsConfig.find(tab => tab.match && tab.match(path));
        return foundTab ? foundTab.key : 'history';
    };

    const [tab, setTab] = useState(getInitialTab());

    // Atualizar a aba quando a rota mudar
    useEffect(() => {
        const newTab = getInitialTab();
        if (newTab !== tab) {
            setTab(newTab);
        }
    }, [location.pathname, tab]);

    const memoizedBalance = useMemo(() => {
        return <Balance />;
    }, []); // Array vazio significa que só renderiza uma vez

    const activeTabConfig = tabsConfig.find(t => t.key === tab);

    // --- Onboarding Logic ---
    const [loadingWallet, setLoadingWallet] = useState(true);
    const [walletStatus, setWalletStatus] = useState(null);

    useEffect(() => {
        fetchWalletStatus();
    }, []);

    async function fetchWalletStatus() {
        try {
            const { data } = await api.get("wallet");

            setWalletStatus(data?.statuses?.general);
        } catch (e) {
            console.error("Failed to load wallet status", e);
        } finally {
            setLoadingWallet(false);
        }
    }

    if (loadingWallet) {
        return (
            <Screen loading={true}>

            </Screen>
        );
    }

    // If status is not approved (active)
    if (walletStatus !== 'active') {
        return (
            <Screen title={[{ "title": "Banking", "url": "banking", iconLeft: <AccountBalanceRounded /> }]}>
                <div className="screen-body">
                    <BankOnboardingCard />
                </div>
            </Screen>
        );
    }

    return (
        <>
            <Screen title={[
                {
                    "title": "Banking",
                    "url": "banking",
                    iconLeft: <AccountBalanceRounded />
                },
                ...(activeTabConfig?.screenTitle ? [{
                    "title": activeTabConfig.screenTitle,
                    "url": activeTabConfig.screenUrl,
                    ...(activeTabConfig.iconLeft ? { iconLeft: activeTabConfig.iconLeft } : {})
                }] : [])
            ]}>
                <div className="screen-body">
                    {memoizedBalance}

                    <TabsSelector
                        tabs={tabsConfig.filter(t => t.showInTabs).map(t => ({
                            key: t.key,
                            label: t.label,
                            disabled: t.disabled,
                            badge: t.badge
                        }))}
                        value={tab}
                        onChange={(newTabKey) => {
                            setTab(newTabKey);
                            const targetTab = tabsConfig.find(t => t.key === newTabKey);
                            if (targetTab && targetTab.path) {
                                navigate(targetTab.path);
                            }
                        }}
                    />

                    {activeTabConfig?.component}
                </div>
            </Screen >
        </>
    );
}

